export default __webpack_public_path__ + "static/media/logout.ff625fc5.svg";